import { TransactionItem } from "./TransactionItem";
import type { ITransaction } from "../interfaces/transactions";
import { useTranslation } from "react-i18next";
import { APP_ROUTES } from "../constants";
import { useRouteWithToken } from "../hooks/useRouteWithToken";
import { useStore } from "../store/globalState";
import { ScrollFadeIndicator } from "./ScrollFadeIndicator";

export interface TransactionsHistoryProps {
  items: unknown[];
}

export const TransactionsHistory: React.FC<TransactionsHistoryProps> = ({
  items = [],
}) => {
  const { t } = useTranslation();
  const { redirectTo } = useRouteWithToken();
  const { theme } = useStore();
  const bodyCopy = theme.whiteView.bodyCopy;
  const isEmpty = items.length === 0;

  const handleTransactionClick = (operationId: string) => {
    redirectTo(`${APP_ROUTES.RECEIPT_SUMMARY_PAGE.replace(":operationId", operationId)}`);
  };

  return (
    <>
      <h3 className="normal-text foreground" style={{ marginBlock: "24px" }}>
        {t("transactions.title")}
      </h3>
      <section className="transactions-history-container">
        <ScrollFadeIndicator color={bodyCopy} />
        {isEmpty ? (
          <section className="transactions-history-empty">
            <p className="empty-title foreground">
              <b>{t("transactions.emptyTitle")}</b>
            </p>
            <p className="empty-description muted-foreground">
              {t("transactions.emptyDescription")}
            </p>
          </section>
        ) : (
          <section className="transactions-history-list">
            {items.map((transaction, index) => (
              <TransactionItem
                key={index}
                {...(transaction as ITransaction)}
                onClick={handleTransactionClick}
              />
            ))}
          </section>
        )}
      </section>
    </>
  );
};
